import React, { useState } from 'react';
import { Bell } from 'lucide-react';
import { useUnreadCount } from '../../hooks/useNotifications';
import { NotificationDrawer } from './NotificationDrawer';

export function NotificationBell() {
  const [open, setOpen] = useState(false);
  const { data: unread } = useUnreadCount();
  const count = unread?.count ?? 0;

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        aria-label={`Notifiche${count > 0 ? ` (${count} non lette)` : ''}`}
        style={{
          position: 'relative',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: count > 0 ? 'var(--color-primary)' : 'var(--color-text-faint)',
          padding: '0.375rem',
          borderRadius: 'var(--radius-interactive)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'color var(--transition-interactive)',
        }}
        onMouseEnter={e => { e.currentTarget.style.color = 'var(--color-primary)'; }}
        onMouseLeave={e => { e.currentTarget.style.color = count > 0 ? 'var(--color-primary)' : 'var(--color-text-faint)'; }}
      >
        <Bell size={18} />
        {count > 0 && (
          <span style={{
            position: 'absolute',
            top: -2,
            right: -2,
            minWidth: 16,
            height: 16,
            borderRadius: 8,
            background: 'var(--color-error)',
            color: '#fff',
            fontSize: 10,
            fontWeight: 700,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0 3px',
            lineHeight: 1,
          }}>
            {count > 99 ? '99+' : count}
          </span>
        )}
      </button>
      <NotificationDrawer open={open} onClose={() => setOpen(false)} />
    </>
  );
}
